import { CSSProgressiveHeading01 } from "@caisy/league";
import styled from "styled-components";

export const SMaintenanceWarningModalTitle = styled.h2`
  ${CSSProgressiveHeading01};
  color: var(--text-01);
`;
